import { Component, OnInit } from '@angular/core';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { AutorAdminListResponse } from 'src/app/modal/autor/autorAdminListResponse';
import { AutorAdminListBean } from 'src/app/modal/autor/autorAdminBean';

import { AutorService } from 'src/app/service/autor/autor.service';
import { ModalidadService } from 'src/app/service/modalidad/modalidad.service';

import { MDBModalRef } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';
import { Modalidad } from 'src/app/modal/modalidad/modalidad';
@Component({
  selector: 'app-bus-modalidades',
  templateUrl: './bus-modalidades.component.html',
  styleUrls: ['./bus-modalidades.component.scss']
})
export class BusModalidadesComponent implements OnInit {

  constructor(private modalidadService:ModalidadService,
    private utilitarioService: UtilitarioService,
    public  modalRef: MDBModalRef, 
    ) { }

  headElements = ['Modalidad','Acción'];
  txtdescripcion_bus:String = "";
  listModalidad:Modalidad = new Modalidad();
  
  //variables del padre
  x_titulo:String;
  //action del padre para el retorno de datos
  action: Subject<AutorAdminListBean> = new Subject();

  page = 1;
  pageSize = 9;

  ngOnInit(): void {
    this.cargarDatoInicial();  
  }

  onBuscar(){
    this.utilitarioService.loading = true;
    this.modalidadService.obtenerAdminList().subscribe(data=>{
      this.listModalidad = data;      
      this.utilitarioService.loading = false;
    })
  }

  onSeleccionar(objetoAutor:AutorAdminListBean){    
    this.action.next(objetoAutor);
    this.modalRef.hide();
  }

  onClosemodal(){
    this.modalRef.hide();
  }

  cargarDatoInicial(){

    this.onBuscar();

  }

}
